import React, { useState, useEffect } from "react";
import { BASE_URL } from "../env";
import { useHistory, useParams } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
// import { CSVExport } from 'react-bootstrap-table2-toolkit';
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider, {
	CSVExport,
	Search,
} from "react-bootstrap-table2-toolkit";

const { SearchBar } = Search;
const { ExportCSVButton } = CSVExport;

const QuizScore = () => {
	const { id } = useParams();

	const [tabledata, settabledata] = useState([]);
	const [courseData, setCourseData] = useState({});
	const [title, setTitle] = useState([]);

	useEffect(() => {
		fetch(BASE_URL + "/getQuizEXamById/" + id)
			.then((res) => res.json())
			.then((data) => {
				console.log(data);
				setCourseData(data?.data?.questions);
				// console.log(courseData);
			});
	}, []);

	useEffect(() => {
		fetch(BASE_URL + "/getQuizAllEXam")
			.then((res) => res.json())
			.then((dta) => {
				console.log(dta);
				setTitle(dta?.data);
			});
	}, []);

	let maintitle;
	for (var i = 0; i < title.length; ++i) {
		if (title[i]?._id == id) maintitle = title[i]?.examName;
	}

	let newdata = [];
	useEffect(() => {
		for (var i = 0; i < courseData.length; i++) {
			newdata.push({
				sno: i + 1,
				question: courseData[i],
				correctanswer: courseData[i],
			});
		}
		settabledata(newdata);
		// console.log(JSON.stringify(newdata));
	}, [courseData]);

	let priceFilter;

	const columns = [
		{
			dataField: "sno",
			text: "S no.",
			sort: true,
			headerStyle: () => {
				return { width: "5%", backgroundColor: "#133d6a" };
			},
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
			}),
		},

		{
			dataField: "question",
			text: "Questions ",
			sort: true,
			formatter: (cell) => (
				<a href={`/quizEditform/${cell._id}`}> {cell.question} </a>
			),
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
			}),
			headerStyle: () => {
				return { width: "10%", backgroundColor: "#133d6a" };
			},
		},
		{
			dataField: "correctanswer",
			text: "Correct Answer",
			sort: true,
			formatter: (cell) => (
				<a href={`/quizEditform/${cell._id}`}> {cell.correctAnswer} </a>
			),
			filter: textFilter(),
			headerStyle: () => {
				return { width: "10%", backgroundColor: "#133d6a" };
			},
		},
	];
	const [rowcount, setRowcount] = useState(tabledata.length);
	const handleDataChange = ({ dataSize }) => {
		setRowcount(dataSize);
	};

	const numberStyle = {
		border: "2px solid black",
		boxShadow: "4px 4px rgba(93, 93, 93)",
		borderRadius: "20px",
		fontFamily: "Poppins-Bold",
		color: "white",
	};

	return (
		<>
			<div className="text-centre my-4">
				<h1
					style={{
						fontFamily: "Poppins-Bold",
						color: "#185adb",
						textAlign: "center",
					}}
				>
					<span style={{ color: "black" }}> {maintitle} </span>
				</h1>
			</div>

			<div className="mx-2 w-25 p-3 bg-dark " style={numberStyle}>
				Row Count:<span style={{ color: "yellow" }}>{rowcount}</span>
			</div>
			<div className="text-center my-3">
				<ToolkitProvider
					keyField={"sno"}
					data={tabledata}
					columns={columns}
					exportCSV={{
						fileName: "scores_results.csv",
						blobType: "text/csv;charset=ansi",
						onlyExportFiltered: true,
						exportAll: false,
					}}
					search
				>
					{(props) => (
						<div>
							<div className="d-flex justify-content-between">
								<ExportCSVButton
									{...props.csvProps}
									className="btn btn-md bg-warning my-2 "
									style={{
										borderRadius: "10px",
										marginLeft: "20px",
									}}
								>
									Download All Data
								</ExportCSVButton>
								<SearchBar
									{...props.searchProps}
									style={{
										width: "300px",
										height: "5px",
										marginRight: "20px",
									}}
								/>
							</div>
							<br />
							<BootstrapTable
								{...props.baseProps}
								filter={filterFactory()}
								onDataSizeChange={handleDataChange}
								// condensed
								bootstrap4
								loading
								// classes="text-white"
								striped
							/>
						</div>
					)}
				</ToolkitProvider>
			</div>
		</>
	);
};

export default QuizScore;
